
import product1 from './ProductsImages/amrutsudhabig.jpg'
import product2 from './ProductsImages/amrutkumbhabig.jpg'


let allProducts = 
[
  {
    "productId": "1",
    "title": "Ayurvedic Thyroid Tablet",
    "cat": "Thyroid Carr",
    "price": "529",
    "description": "good",
    "color": "red",
    "productImages": [
      "image1.jpg",
      "image1.jpg",
      "image1.jpg"
    ]
  }
]

export default allProducts;